import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=017a075a&"
import script from "./upgrade.vue?vue&type=script&lang=ts&"
export * from "./upgrade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports